import { render, staticRenderFns } from "./hotBlock.vue?vue&type=template&id=6abddfbe&scoped=true"
import script from "./hotBlock.vue?vue&type=script&lang=js"
export * from "./hotBlock.vue?vue&type=script&lang=js"
import style0 from "./hotBlock.vue?vue&type=style&index=0&id=6abddfbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abddfbe",
  null
  
)

export default component.exports